import { useLang } from '@/i18n';
import { useProductStore } from '../../../ProductProvider';
import { IPageStatus } from '../../../config/IPageStatus';

export default function useStatusLang(mod: string) {
    const { t: sourceT } = useLang(mod);
    const { pageStatus } = useProductStore();
    const map = {
        [IPageStatus.statusA]: 'statusa_',
        [IPageStatus.statusB]: 'statusb_',
        [IPageStatus.statusC]: 'statusc_',
    };
    const prefix = map[pageStatus];

    function t(key: string, ...args: any[]) {
        const ctext = sourceT(prefix + key, ...args);

        if (ctext) return ctext;
        return sourceT(key, ...args);
    }
    t.rich = sourceT.rich;

    return {
        t,
    };
}
